module.exports = __webpack_public_path__ + "94c3a69b7657c1c4f39a74e9a1643e36.ttf";